import { Viewer } from "@photo-sphere-viewer/core";
import { AutorotatePlugin } from "@photo-sphere-viewer/autorotate-plugin";

import "@photo-sphere-viewer/core/index.css";
import "./style.css";

/**
 * Start age-gate script
 */

(function ($, elementorFrontend) {
  "use strict";

  var PhotoSphereViewer = function ($scope, $) {
    var $container = $scope.find(".photo-sphere-viewer");

    if (!$container.length) {
      return;
    }

    $.each($container, function (index, val) {
      var $this = $(this);

      const settings = $this.data("settings");
      const updatedSettings = {
        ...settings,
        navbar: settings.navbar || false,
      };
      new Viewer({
        ...updatedSettings,
        plugins: settings?.navbar?.includes('autorotate')
          ? [AutorotatePlugin.withConfig({
            autostartDelay: 1000,
            autorotatePitch: '5deg',
          })]
          : [],
      });
    });
  };

  jQuery(window).on("elementor/frontend/init", function () {
    elementorFrontend.hooks.addAction(
      "frontend/element_ready/photo-sphere-viewer.default",
      PhotoSphereViewer
    );
  });
})(jQuery, window.elementorFrontend);

/**
 * End age-gate script
 */


// init shortcodes scripts
var PSV_Container = document.querySelectorAll(".xero-psv-container");
for (let i = 0; i < PSV_Container.length; i++) {
  let PSV_ID = PSV_Container[i].firstElementChild.getAttribute("id");
  PSV_ID = document.getElementById(PSV_ID);
  const settings = PSV_ID.getAttribute("data-settings");
  const parsedSettings = JSON.parse(settings || "{}");

  // Ensure navbar is ordered consistently for shortcode viewers
  const desiredOrder = [
    "zoom",
    "move",
    "autorotate",
    "caption",
    "download",
    "fullscreen",
    "description",
  ];

  let navbar = parsedSettings.navbar;


  if (navbar == "") {
    navbar = false;
  } else if (Array.isArray(navbar)) {
    navbar = navbar
      .slice()
      .sort((a, b) => desiredOrder.indexOf(a) - desiredOrder.indexOf(b));
  } else if (typeof navbar === "string" && navbar.length > 0) {
    const parts = navbar.split(",");
    navbar = parts.sort(
      (a, b) => desiredOrder.indexOf(a) - desiredOrder.indexOf(b)
    );
  }


  if (PSV_ID) {
    new Viewer({
      ...parsedSettings,
      navbar: Array.isArray(navbar) ? navbar : false,
      plugins: Array.isArray(navbar) && navbar.includes("autorotate")
        ? [
          AutorotatePlugin.withConfig({
            autostartDelay: 1000,
            autorotatePitch: "5deg",
          }),
        ]
        : [],
    });
  }
}